module.exports = __webpack_public_path__ + "img/tonearm-straight.768e4faf.png";